import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/summary-total-dex.svg'
import _imports_1 from '@/app/ui/assets/svg/summary-dispute-accept.svg'
import _imports_2 from '@/app/ui/assets/svg/summary-dex-not-match.svg'
import _imports_3 from '@/app/ui/assets/svg/summary-dex-complete.svg'


const _hoisted_1 = { class: "py-4 grid grid-cols-4 gap-4" }
const _hoisted_2 = { class: "flex flex-row p-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "max-w-none w-20",
  alt: "total-dex"
}, null, -1)
const _hoisted_4 = { class: "pl-8 flex flex-col" }
const _hoisted_5 = { class: "font-semibold text-14px text-gray-lp-600" }
const _hoisted_6 = { class: "flex flex-col" }
const _hoisted_7 = { class: "text-24px font-semibold" }
const _hoisted_8 = { class: "text-10px" }
const _hoisted_9 = { class: "flex flex-row p-4" }
const _hoisted_10 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "max-w-none w-20",
  alt: "total-dex"
}, null, -1)
const _hoisted_11 = { class: "pl-8 flex flex-col pt-3" }
const _hoisted_12 = { class: "font-semibold text-14px text-gray-lp-600" }
const _hoisted_13 = { class: "text-24px font-semibold" }
const _hoisted_14 = { class: "flex flex-row p-4" }
const _hoisted_15 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "max-w-none w-20",
  alt: "total-dex"
}, null, -1)
const _hoisted_16 = { class: "pl-8 flex flex-col pt-3" }
const _hoisted_17 = { class: "font-semibold text-14px text-gray-lp-600" }
const _hoisted_18 = { class: "text-24px font-semibold" }
const _hoisted_19 = { class: "flex flex-row p-4" }
const _hoisted_20 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  class: "max-w-none w-20",
  alt: "total-dex"
}, null, -1)
const _hoisted_21 = { class: "pl-8 flex flex-col pt-3" }
const _hoisted_22 = { class: "font-semibold text-14px text-gray-lp-600" }
const _hoisted_23 = { class: "text-24px font-semibold" }
const _hoisted_24 = { class: "flex flex-row p-4" }
const _hoisted_25 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "max-w-none w-20",
  alt: "total-dex"
}, null, -1)
const _hoisted_26 = { class: "pl-8 flex flex-col pt-3" }
const _hoisted_27 = { class: "font-semibold text-14px text-gray-lp-600" }
const _hoisted_28 = { class: "text-24px font-semibold" }
const _hoisted_29 = { class: "flex flex-row p-4" }
const _hoisted_30 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "max-w-none w-20",
  alt: "total-dex"
}, null, -1)
const _hoisted_31 = { class: "pl-8 flex flex-col pt-3" }
const _hoisted_32 = { class: "font-semibold text-14px text-gray-lp-600" }
const _hoisted_33 = { class: "text-24px font-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Card, null, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('dexAssessment.summaryTotalTicket')), 1),
            _createVNode("div", _hoisted_6, [
              _createVNode("span", _hoisted_7, _toDisplayString(_ctx.data.daTicketTotal) + "/" + _toDisplayString(_ctx.data.daTicketQuota), 1),
              _createVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('dexAssessment.summaryTicketQuota')), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Card, null, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode("div", _hoisted_11, [
            _createVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('dexAssessment.summaryTicketFinished')), 1),
            _createVNode("div", _hoisted_13, _toDisplayString(_ctx.data.daTicketFinished), 1)
          ])
        ])
      ]),
      _: 1
    }),
    (_ctx.isAgentDexL1)
      ? (_openBlock(), _createBlock(_component_Card, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode("div", _hoisted_16, [
                _createVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('dexAssessment.summaryTicketInvalid')), 1),
                _createVNode("div", _hoisted_18, _toDisplayString(_ctx.data.daTicketInvalidToday) + "/" + _toDisplayString(_ctx.data.daTicketFinished), 1)
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.isAgentDexL1)
      ? (_openBlock(), _createBlock(_component_Card, { key: 1 }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_19, [
              _hoisted_20,
              _createVNode("div", _hoisted_21, [
                _createVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('dexAssessment.summaryTicketValid')), 1),
                _createVNode("div", _hoisted_23, _toDisplayString(_ctx.data.daTicketValidToday) + "/" + _toDisplayString(_ctx.data.daTicketFinished), 1)
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.isAgentDexL2)
      ? (_openBlock(), _createBlock(_component_Card, { key: 2 }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_24, [
              _hoisted_25,
              _createVNode("div", _hoisted_26, [
                _createVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('dexAssessment.summaryTicketL1Finished')), 1),
                _createVNode("div", _hoisted_28, _toDisplayString(_ctx.data.daTicketInvalidToday) + "/" + _toDisplayString(_ctx.data.daTicketFinished), 1)
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.isAgentDexL2)
      ? (_openBlock(), _createBlock(_component_Card, { key: 3 }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_29, [
              _hoisted_30,
              _createVNode("div", _hoisted_31, [
                _createVNode("div", _hoisted_32, _toDisplayString(_ctx.$t('dexAssessment.summaryTicketDisputeFinished')), 1),
                _createVNode("div", _hoisted_33, _toDisplayString(_ctx.data.daTicketDisputeToday) + "/" + _toDisplayString(_ctx.data.daTicketFinished), 1)
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}